import _ from "lodash";
import useEmblaCarousel from "embla-carousel-react";
import React from "react";

import StyledSlider from "./styled-slider";

function EmblaCarousel({
  gridItem,
  naturalSlideWidth,
  naturalSlideHeight,
  selectedItem,
  onSetSelectedItem,
  onUnsetSelectedItem,
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ watchDrag: false });
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  React.useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi]);

  const totalSlides = gridItem.gridItemMediaObjects.length;

  return (
    <React.Fragment>
      <StyledSlider
        emblaRef={emblaRef}
        emblaApi={emblaApi}
        gridItem={gridItem}
        naturalSlideHeight={naturalSlideHeight}
        naturalSlideWidth={naturalSlideWidth}
        onSetSelectedItem={onSetSelectedItem}
        onUnsetSelectedItem={onUnsetSelectedItem}
        selectedItem={selectedItem}
      />
      {totalSlides > 1 && (
        <div className="embla__dots">
          {gridItem.gridItemMediaObjects.map((_, index) => (
            <button
              key={index}
              className={`embla__dot${index === selectedIndex ? " embla__dot--selected" : ""}`}
              type="button"
            >
              <span />
            </button>
          ))}
        </div>
      )}
    </React.Fragment>
  );
}

export default function Full(props) {
  const { gridItems } = props;
  const [selectedItem, setSelectedItem] = React.useState(null);

  React.useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, []);

  React.useEffect(() => {
    const handleScroll = _.throttle(() => {
      const items = document.querySelectorAll('.ApexFull-item');
      const viewportHeight = window.innerHeight;

      for (const item of items) {
        const rect = item.getBoundingClientRect();
        const itemHeight = rect.height;
        const threshold = Math.min(itemHeight * 0.5, viewportHeight * 0.3);

        if (rect.top <= threshold && rect.bottom > threshold) {
          const hash = `#${item.id}`;
          if (window.location.hash !== hash) {
            history.replaceState(null, '', hash);
          }
          break;
        }
      }
    }, 100);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleSetSelectedItem(id) {
    setSelectedItem(id);
  }

  function handleUnsetSelectedItem() {
    setSelectedItem(null);
  }

  return (
    <div className="ApexFull">
      {_.map(gridItems, (gridItem) => {
        const firstObj = _.first(gridItem.gridItemMediaObjects);

        let naturalSlideWidth = firstObj.width;
        let naturalSlideHeight = firstObj.height;

        if (firstObj.width / firstObj.height < 3 / 4) {
          naturalSlideWidth = 3;
          naturalSlideHeight = 4;
        } else if (firstObj.width / firstObj.height > 16 / 9) {
          naturalSlideWidth = 16;
          naturalSlideHeight = 9;
        }

        return (
          <div className="ApexFull-item" id={`item-${gridItem.id}`} key={gridItem.id}>
            <div className="ApexFull-content">
              <EmblaCarousel
                gridItem={gridItem}
                naturalSlideWidth={naturalSlideWidth}
                naturalSlideHeight={naturalSlideHeight}
                selectedItem={selectedItem}
                onSetSelectedItem={handleSetSelectedItem}
                onUnsetSelectedItem={handleUnsetSelectedItem}
              />

              {gridItem.caption && (
                <div
                  className="ApexFull-caption Markdown"
                  dangerouslySetInnerHTML={{
                    __html: gridItem.formattedCaption,
                  }}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
